import { useState } from "react";
import { Link, Navigate, useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { AuthLayout } from "@/components/app/AuthLayout";
import { Field } from "@/components/app/kit";
import { api, formatApiError } from "@/lib/api";
import { useAuth, homeFor } from "@/context/AuthContext";

export default function Login() {
  const { me, setMe } = useAuth();
  const navigate = useNavigate();
  const [f, setF] = useState({ email: "", password: "" });
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  if (me) return <Navigate to={homeFor(me)} replace />;

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      const { data } = await api.post("/auth/login", f);
      setMe(data);
      navigate(homeFor(data), { replace: true });
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <AuthLayout title="Connexion" subtitle="Accédez à votre espace cabinet ou à l'administration de la plateforme.">
      <form onSubmit={submit} className="space-y-5" data-testid="login-form">
        <Field label="Adresse e-mail" required>
          <Input type="email" autoComplete="email" value={f.email} onChange={(e) => setF({ ...f, email: e.target.value })} required data-testid="login-email-input" />
        </Field>
        <Field label="Mot de passe" required>
          <Input type="password" autoComplete="current-password" value={f.password} onChange={(e) => setF({ ...f, password: e.target.value })} required data-testid="login-password-input" />
        </Field>
        {error && <p className="text-sm text-red-600 bg-red-50 border border-red-200 rounded-lg px-3 py-2" data-testid="login-error">{error}</p>}
        <Button type="submit" className="w-full h-11" disabled={busy} data-testid="login-submit-button">
          {busy && <Loader2 className="h-4 w-4 animate-spin mr-2" />}Se connecter
        </Button>
        <Link to="/mot-de-passe-oublie" className="block text-sm text-sky-700 hover:underline" data-testid="forgot-password-link">Mot de passe oublié ?</Link>
      </form>
    </AuthLayout>
  );
}
